import React from 'react';
import SEOLandingPage from '../SEOLandingPage';
import { Smartphone, Video, TrendingUp, Play } from 'lucide-react';

const YouTubeShortsGeneratorPage: React.FC = () => {
  return (
    <SEOLandingPage 
      title="YouTube Shorts Generator"
      description="Create viral YouTube Shorts and TikToks with our physics animation generator. The easiest way for creators to make satisfying, high-retention short videos."
      keywords="YouTube shorts generator, TikTok video maker, reels creator, short form content tool, viral physics shorts, fun circle games, funcirclegames, fun circle games creator studio"
      heroTitle="Viral Shorts & Reels Generator"
      heroSubtitle="Dominate the short-form feeds with hypnotic physics simulations. Export perfectly formatted 9:16 vertical videos in seconds."
      features={[
        {
          title: "Native 9:16 Output",
          description: "Zero editing required. Your simulations are perfectly framed for modern vertical video feeds.",
          icon: <Smartphone className="w-6 h-6" />
        },
        {
          title: "High Retention",
          description: "Physics loops are proven to keep viewers watching longer, boosting your algorithmic performance.",
          icon: <TrendingUp className="w-6 h-6" />
        },
        {
          title: "Short Duration Loops",
          description: "Create the perfect 15, 30, or 60-second loops that maximize watch time percentages.",
          icon: <Play className="w-6 h-6" />
        },
        {
          title: "Channel Automation",
          description: "Streamline your workflow to produce multiple shorts a day, keeping your upload schedule consistent.",
          icon: <Video className="w-6 h-6" />
        }
      ]}
      contentSnippet="Short-form video is currently the fastest way to grow an audience. Our YouTube Shorts generator removes the friction from content creation, allowing you to focus on the 'fun' part — designing beautiful physics environments. Whether you're targeting TikTok's 'For You' page or YouTube's Shorts shelf, our generator ensures your content looks professional and performs at its peak."
      currentTool="/youtube-shorts-generator"
    />
  );
};

export default YouTubeShortsGeneratorPage;
